<template>
  <div class="nav-home" :class="{ 'nav-frame': step }">
    <div class="nav-main clearfix">
      <div class="nav-logo">
        <img @click="goTo('/index')" v-if="step" src="../../src/assets/images/icon/360logo.png" alt="" />
        <img @click="goTo('/index')" v-else src="../../src/assets/images/icon/360logo-w.png" alt="" />
      </div>
      <div class="nav-item">
        <div class="nav-data" @click="goTo('/index')" :class="{
          'home-link': $route.path == '/' || $route.path == '/index',
        }">
          <p>网站首页<span class="nav-line"></span></p>
        </div>
        <div class="nav-data" @click="goTo('/join')" :class="{ 'home-link': $route.path == '/join' }">
          <p>走进百昌<span class="nav-line"></span></p>
          <div class="nav-group animated fadeInUp">
            <div class="nav-g-data" @click.stop="goTo('/join', 'dotJdszzc')">
              董事长致辞
            </div>
            <div class="nav-g-data" @click.stop="goTo('/join', 'dotJjtjs')">
              集团介绍
            </div>
            <div class="nav-g-data" @click.stop="goTo('/join', 'dotJfzlc')">
              发展历程
            </div>
            <div class="nav-g-data" @click.stop="goTo('/join', 'dotJzygd')">
              主要股东
            </div>
            <div class="nav-g-data" @click.stop="goTo('/join', 'dotJkgzgs')">
              控股子公司
            </div>
            <div class="nav-g-data" @click.stop="goTo('/join', 'dotJtgg')">
              集团高管
            </div>
            <div class="nav-g-data" @click.stop="goTo('/join', 'dotRyzz')">
              荣誉资质
            </div>
            <div class="nav-g-data" @click.stop="goTo('/join', 'dotJqywh')">
              企业文化
            </div>

          </div>
        </div>
        <div class="nav-data" @click="goTo('/product')" :class="{
          'home-link':
            $route.path == '/product' ||
            $route.path == '/product/productCenter' ||
            $route.path == '/product/digitalBC' ||
            $route.path == '/product/digitalBC/introduce' ||
            $route.path == '/product/digitalBC/caseShow' ||
            $route.path == '/product/digitalBC/caseDetail'
        }">
          <p>产品中心<span class="nav-line"></span></p>
          <div class="nav-group animated fadeInUp">
            <div class="nav-g-data" @click.stop="goTo('/product', 'dotPzcc')">
              再查查
            </div>
            <div class="nav-g-data" @click.stop="goTo('/product', 'dotPgwpm')">
              百昌拍卖平台
            </div>
            <div class="nav-g-data" @click.stop="goTo('/product', 'dotPsy')">
              师爷AI
            </div>
            <div class="nav-g-data" @click.stop="goTo('/product', 'dotPgjdt')">
              百昌估值地图
            </div>
            <!-- <div class="nav-g-data" @click.stop="goTo('/product', 'dotSzbc')">
              数字百昌
            </div> -->
            <div class="nav-g-data" @click.stop="goTo('/product', 'dotPzls')">
              百昌找律师
            </div>
            <div class="nav-g-data" @click.stop="goTo('/product', 'dotPlgj')">
              楼管家
            </div>
            <div class="nav-g-data" @click.stop="goTo('/product', 'dotPsx')">
              首席
            </div>
            <div class="nav-g-data" @click.stop="goTo('/product', 'dotPbcsz')">
              百昌数智
            </div>
            <div class="nav-g-data" @click.stop="goTo('/product', 'dotPyhlhtsc')">
              赢回来
            </div>
          </div>
        </div>
        <div class="nav-data" @click="goTo('/cooperate')" :class="{ 'home-link': $route.path == '/cooperate' }">
          <p>业务中心<span class="nav-line"></span></p>
        </div>
        <div class="nav-data" @click="goTo('/news')" :class="{
          'home-link':
            $route.path == '/news/newsCenter' ||
            $route.path == '/news/newsListPages' ||
            $route.path == '/news/newsDetails',
        }">
          <p>新闻中心<span class="nav-line"></span></p>
        </div>
        <div class="nav-data" @click="goTo('/about')" :class="{ 'home-link': $route.path == '/about' }">
          <p>关于我们<span class="nav-line"></span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headTop",
  data() {
    return {
      step: false,
    };
  },
  mounted() {
    if (this.$route.path == "/" || this.$route.path == "/index") {
      window.addEventListener("scroll", this.homeScroll, true);
    } else {
      this.step = true;
      window.removeEventListener("scroll", this.homeScroll, true);
    }
  },
  methods: {
    homeScroll() {
      if (this.$route.path == "/" || this.$route.path == "/index") {
        let scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        if (scrollTop >= 550) {
          this.step = true;
        } else {
          this.step = false;
        }
      } else {
        this.step = true;
      }
    },
    goTo(url, drop) {
      if (drop) {
        if (this.$route.query.anchor == drop) {
          if (document.querySelector("#" + drop)) {
            document.querySelector("#" + drop).scrollIntoView();
          }
        }
        this.$router.push(url + "?anchor=" + drop);
      } else {
        this.$router.push(url);
      }
    },
  },
  watch: {
    $route() {
      this.$store.commit("UPSTATAFEEDBACK", false);
      this.homeScroll();
      if (this.$route.path == "/" || this.$route.path == "/index") {
        window.addEventListener("scroll", this.homeScroll, true);
      } else {
        this.step = true;
        window.removeEventListener("scroll", this.homeScroll, true);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.nav-home {
  width: 100%;
  min-width: 1200px;
  height: 120px;
  left: 0;
  top: 0;
  position: absolute;
  z-index: 100;
  background: url("../assets/images/index/bg-l.png") repeat;

  .nav-main {
    width: 1200px;
    position: relative;
    margin: 0 auto;
    height: 80px;

    .nav-logo {
      float: left;
      padding-left: 45px;
      width: 180px;
      height: 40px;
      overflow: hidden;
      padding-top: 20px;

      img {
        display: block;
        width: 230px;
        height: 40px;
      }
    }

    .nav-item {
      float: right;
      font-size: 16px;
      font-family: "SourceHanSansCN-Regular";
      color: #fff;
      padding-right: 14px;

      .nav-data {
        cursor: pointer;
        float: left;
        height: 80px;
        line-height: 80px;
        margin-left: 20px;
        position: relative;
        padding: 0 10px;

        p {
          position: relative;
        }

        .nav-line {
          position: absolute;
          width: 0;
          left: 0;
          top: 50px;
          height: 3px;
          background: #33b9ff;
          transition: all 0.5s;
        }

        .nav-group {
          font-size: 14px;
          position: absolute;
          top: 65px;
          left: 50%;
          width: 140px;
          margin-left: -70px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 9px;
          display: none;
          padding: 10px 0;
          box-shadow: 0 10px 16px rgba(0, 0, 0, 0.1);
          font-weight: normal;

          .nav-g-data {
            line-height: 46px;
            height: 46px;
            width: 100%;
            color: #333;
            text-align: center;
            transition: all 0.5s;
            border-radius: 5px;

            &:hover {
              // background-color: rgba(255, 255, 255, 0.9);
              transform: scale(1.5);
              color: #1553b5;
              font-weight: bold;
            }
          }
        }

        &:hover {
          .nav-line {
            width: 100%;
          }

          .nav-group {
            display: block;
          }
        }
      }

      .home-link {
        font-weight: bold;

        .nav-line {
          width: 100%;
        }
      }
    }
  }
}

.nav-frame {
  background: none;
  background-color: #fff;
  height: 80px;
  left: 0;
  top: 0;
  position: fixed;
  transition: background-color 0.5s;
  box-shadow: 0 10px 16px rgba(0, 0, 0, 0.1);

  .nav-main {
    .nav-item {
      color: #333;
    }
  }
}
</style>
